<div class="td-wb-integration__container"
     [class.td-wb-integration__container--background-color]="config()?.backgroundColor === true">
  @let currentConfig = config();
  @if (currentConfig !== undefined && currentConfig.pageHeader !== undefined) {
    <td-wb-page-header aria-hidden="true">
      <td-wb-page-header-title [translate]="'tdWb.integration.' + currentConfig.pageHeader + '.header.TITLE'"/>
    </td-wb-page-header>
  }
  @if (currentConfig !== undefined && !errorState()) {
    <div class="td-wb-integration__iframe-container">
      <iframe #iframe
              [title]="currentConfig.title | translate"
              name="main"
              id="main"
              class="td-wb-integration__iframe"
              (load)="onIframeLoad()"
              [class.td-wb-integration__iframe--show]="!currentConfig.fixed || contentReady()"
              [src]="iframeSource()"
              [height]="currentConfig.height"
              [width]="iframeWidth()"
              [scrolling]="currentConfig.fixed ? 'yes' : 'no'"
              allowfullscreen
              webkitallowfullscreen
              mozallowfullscreen>
      </iframe>
    </div>
  } @else {
    <td-wb-integration-error/>
  }
</div>
